module.exports = __webpack_public_path__ + "media/navi/populife_close-8934718e.png";